import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";

const useStyles = (theme) => ({
  container: {
    mt: { xs: "94px", md: "113px", lg: "128px", xl: "143px" },
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px", md: "16px" },
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  subtitle: {
    color: theme.palette.blue.main,
    fontSize: { xs: "32px", md: "43px", lg: "54px", xl: "65px" },
    lineHeight: { xs: "36px", md: "45px", lg: "54px", xl: "65px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    maxWidth: { xs: "225px", md: "447px", lg: "558px", xl: "667px" },
    height: { xs: "72px", md: "73.25px", lg: "74.5px", xl: "79px" },
    mt: { xs: "13px", md: "22px", lg: "26.5px", xl: "31px" },
  },
  span: {
    fontWeight: "bold",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
});

const BenefitsTitle = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const componentName = "BenefitsTitle";
  const translation = useTranslation(pathname, componentName);
  const { title, subtitle } = translation;

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>

      <Typography sx={classes.subtitle}>
        <span style={classes.span}>{subtitle[0]}</span>
        {subtitle[1]}
      </Typography>
    </Box>
  );
};

export default BenefitsTitle;
